module.exports = __webpack_public_path__ + "videos/mts-products-chats-appointment-moderators.6c74e31.webm";